"use strict";
if(!customElements.get('sticky-cart')) {
  class StickyCart extends HTMLElement {
    constructor() {
      super();
      var _this = this,
        secId = this.dataset.section,
        vr = this.querySelector('#stickyOptions');
  
      window.addEventListener("scroll",function(){
         var y = window.scrollY,
            btn = document.querySelector('.product-form__submit'),
            cartBtn = '300',
            mbQury = window.matchMedia('(max-width: 767px)');
          if(btn) {
            cartBtn = btn.offsetTop + 200;
            if(mbQury.matches === true) cartBtn = btn.offsetTop + window.innerHeight;
          }
          if(y > cartBtn){
           _this.classList.add('active');
          } else {
            _this.classList.remove('active');
          }
      });
      if(vr){
        vr.addEventListener('change', function(e){
            var opt = this.selectedOptions[0],
              vrcontainer = document.getElementById(`variant-selects-${secId}`).querySelectorAll('select, fieldset');
            vrcontainer.forEach((field, index) => {
              if(field.tagName === 'SELECT'){
                field.querySelectorAll("option").forEach((option) => {
                  if(option.value === opt.dataset[`option${index + 1}`]){
                    option.selected = true;
                  }
                });
              } else if(field.tagName === 'FIELDSET'){
                field.querySelectorAll("input").forEach((input) => {
                  input.removeAttribute("checked");
                  if(input.value === opt.dataset[`option${index + 1}`]){
                    input.click();
                  }
                });
              }
            });
        });
      }
  
      this.querySelectorAll('.linkQty').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
  
      const syncQty = document.querySelectorAll(".linkInput");
      syncQty.forEach((input) => {
          input.addEventListener("change", function(){
            const value = this.value;
            syncQty.forEach((otherInput) => {
              if (otherInput !== input) {
                otherInput.value = value;
              }
            });
          });
      });
    }
    onButtonClick(e){
      e.preventDefault();
      const qtyinput = document.querySelector('.mianQty'),
        previousValue = qtyinput.value;
      e.target.name === 'plus' ? qtyinput.stepUp() : qtyinput.stepDown();
      if(previousValue !== qtyinput.value) qtyinput.dispatchEvent(new Event("change"));
    }
  }
  customElements.define("sticky-cart", StickyCart);
}
if(!customElements.get('back-in-stock')){
  class BackInStock extends HTMLElement {
    constructor() {
      super();
      this.bisCookie = 'backinstock'+this.dataset.id;
      this.form = this.querySelector('form');
      this.variant = this.querySelector('.bisVariant');
  
      this.form.addEventListener("submit", this.BackinStockSubmit.bind(this));
  
      window.addEventListener('DOMContentLoaded',function(){
        const error = window.location.href.indexOf('form_type=contact') > -1;
        if(window.location.href.indexOf('contact_posted=true') > -1 || error){
            if(getCookie('contatForm') == 'backinstockform'){
                var bismodal = new tingle.modal({
                      cssClass: ['bismodal'],
                      onClose: function(){
                          setCookie('contatForm','',1);
                      }
                });
                bismodal.setContent(document.getElementById('backStockSuccess'));
                bismodal.open();
                
            }
        }
      });
    }
    BackinStockSubmit(event){
        event.preventDefault();
        var vrId = this.querySelector('.bisVariant').dataset.id,
          cvr = vrId;
        if(getCookie(this.bisCookie) != null){
            cvr = getCookie(this.bisCookie)+'_'+vrId;
        }
        setCookie(this.bisCookie,cvr,1);
        setCookie('contatForm','backinstockform',1);
    }
    checkBackinstock(vr){
      this.variant.value = vr.title;
      this.variant.setAttribute('data-id', vr.id);
      var formMsg = this.querySelector('.bisMsg');
      if(vr.available){
        this.classList.add('hide');
      } else {
        this.classList.remove('hide');
         if(getCookie(this.bisCookie) != null){
           this.form.classList.remove('hide');
           formMsg.classList.add('hide');
           var str = String(getCookie(this.bisCookie)).split("_");
           for(var i=0; i<str.length; i++){
             if(str[i] == vr.id){
               this.form.classList.add('hide');
               formMsg.classList.remove('hide');
             }
           }
         }
      }
     }
  }
  customElements.define("back-in-stock", BackInStock);
}

var tearmFields = document.querySelectorAll('.tearmCheck'),
  dyButs = document.querySelectorAll('.shopify-payment-button__button');

if(tearmFields.length){
  setTimeout(function(){
    dyButs.forEach((btn) => { btn.disabled = true; });
  },300);
  
  tearmFields.forEach((tearm) => {
    tearm.onchange = function(){
      var dyBut = this.closest('.product-form__buttons').querySelector('.shopify-payment-button__button');
      //dyBut.disabled = !this.checked;
    };
  });
  
}
/* GTX printer-model image/validation test - unpublished theme */
(function () {
  var validModels = ['GTX / GTX Pro', 'GTX300'];

  function applyGtxSelection(select) {
    if (!select) return;

    var root = select.closest('.quick_shop') || select.closest('[id^="ProductSection-"]') || document;
    var button = root.querySelector('button[name="add"].product-form__submit');
    var chosen = validModels.indexOf(select.value) !== -1;

    if (button) {
      button.disabled = !chosen;
      button.setAttribute('aria-disabled', chosen ? 'false' : 'true');
      var label = button.querySelector('.txt');
      if (label) {
        if (!button.dataset.gtxOriginalText) button.dataset.gtxOriginalText = label.textContent.trim();
        label.textContent = chosen ? button.dataset.gtxOriginalText : 'Select your printer model';
      }
    }

var gtx300Image = select.getAttribute('data-gtx300-image') || '';
var gtx300Sku = select.getAttribute('data-gtx300-sku') || '';
var originalSku = select.getAttribute('data-original-sku') || '';

var skuText = root.querySelector('.product-sku .variant-sku');
if (skuText) {
  skuText.textContent = select.value === 'GTX300' ? gtx300Sku : originalSku;
}

/* Correct Shopify variant IDs for GTX / GTX Pro and GTX300 */
var variantMap = {
  'BROTBGCX40W07000022': '52844888326482',
  'BROTBGC30W007000122': '55098062504274',

  'BROTBGCX40C07000012': '52844891930962',
  'BROTBGC30C007000112': '55098038059346',

  'BROTBGCX40M07000012': '52844892291410',
  'BROTBGC30M007000112': '55098068435282',

  'BROTBGCX40Y07000012': '52844892553554',
  'BROTBGC30Y007000112': '55098077643090',

  'BROTBGCX40K07000012': '52844892815698',
  'BROTBGC30K007000112': '55098085441874'
};

var selectedSku = select.value === 'GTX300' ? gtx300Sku : originalSku;
var selectedVariantId = variantMap[selectedSku];

if (selectedVariantId) {
  root.querySelectorAll('input[name="id"]').forEach(function(input) {
    input.value = selectedVariantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

    if (select.id === 'gtx-printer-model') {
      var gallery = root.querySelector('media-gallery');
      var imageWrap = gallery ? gallery.querySelector('.pr_lg_img') : null;
      if (imageWrap) {
        imageWrap.style.position = 'relative';
        var overlay = imageWrap.querySelector('.gtx300-model-overlay');
        if (!overlay) {
          overlay = document.createElement('img');
          overlay.className = 'gtx300-model-overlay';
          overlay.alt = 'GTX300 ink';
          overlay.style.position = 'absolute';
          overlay.style.inset = '0';
          overlay.style.width = '100%';
          overlay.style.height = '100%';
          overlay.style.objectFit = 'contain';
          overlay.style.background = '#fff';
          overlay.style.zIndex = '6';
          overlay.style.pointerEvents = 'none';
          overlay.style.display = 'none';
          imageWrap.appendChild(overlay);
        }
        if (gtx300Image) overlay.src = gtx300Image;
        overlay.style.display = select.value === 'GTX300' ? 'block' : 'none';

        if (select.value !== 'GTX300' && gallery && typeof gallery.setActiveMedia === 'function') {
          var originalMediaId = gallery.getAttribute('data-target');
          if (originalMediaId) gallery.setActiveMedia(originalMediaId, true);
        }
      }
    } else if (select.id === 'gtx-printer-model-quick') {
      var quickImage = root.querySelector('.gtx-model-image-quick');
      if (quickImage) {
        var original = quickImage.getAttribute('data-original-src') || quickImage.src;
        quickImage.src = (select.value === 'GTX300' && gtx300Image) ? gtx300Image : original;
      }
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && (event.target.id === 'gtx-printer-model' || event.target.id === 'gtx-printer-model-quick')) {
      applyGtxSelection(event.target);
    }
  });

function initMainSelector() {
  var select = document.getElementById('gtx-printer-model');
  if (!select) return;

  var params = new URLSearchParams(window.location.search);

  if (params.get('gtx300_only') === '1') {
    select.value = 'GTX300';

    var selectorWrap = select.closest('.dd_wrap');
    if (selectorWrap) {
      selectorWrap.style.display = 'none';
    }
  }

  applyGtxSelection(select);
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainSelector);
  } else {
    initMainSelector();
  }
})();

/* GTX bulk printer selector - unpublished theme */
(function () {
  function applyBulkSelection(select) {
    if (!select) return;
    var root = select.closest('.quick_shop') || select.closest('[id^="ProductSection-"]') || document;
    var formId = select.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;
    var hiddenVariant = form ? form.querySelector('input[name="id"]') : root.querySelector('input[name="id"]');
    var button = form ? form.querySelector('button[name="add"].product-form__submit') : root.querySelector('button[name="add"].product-form__submit');
    var selectedOption = select.options[select.selectedIndex];
    var chosen = !!select.value;

    if (hiddenVariant && chosen) {
      hiddenVariant.value = select.value;
      hiddenVariant.disabled = false;
      hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var sku = selectedOption && selectedOption.dataset ? (selectedOption.dataset.sku || '') : '';
    var skuText = root.querySelector('.product-sku .variant-sku');
    if (skuText) skuText.textContent = chosen ? sku : '';

    if (button) {
      button.disabled = !chosen;
      button.setAttribute('aria-disabled', chosen ? 'false' : 'true');
      var label = button.querySelector('.txt');
      if (label) {
        if (!button.dataset.gtxBulkOriginalText) button.dataset.gtxBulkOriginalText = label.textContent.trim();
        label.textContent = chosen ? button.dataset.gtxBulkOriginalText : 'Select your printer model';
      }
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('gtx-bulk-printer-model')) {
      applyBulkSelection(event.target);
    }
  });

  function initBulkSelectors() {
    document.querySelectorAll('.gtx-bulk-printer-model').forEach(applyBulkSelection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBulkSelectors);
  } else {
    initBulkSelectors();
  }
})();